import yup from "src/validators/yup.Module";
import { PessoaDto } from "../../Entidade/Pessoa/Pessoa.Dto";

export interface CTeFiltrarDto {
  codigoStatusEnvio?: string | null;
  dataEmissaoInicial?: Date | null;
  dataEmissaoFinal?: Date | null;
  serie?: number | null;
  id?: number | null;
}

export const CTeFiltrarSchema = yup.object().shape({
  nome: yup
    .string()
    .notRequired()
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
});

export interface CTePessoaDto extends Omit<Partial<PessoaDto>, "codigoMunicipio"> {
  documento: string;
  inscricaoEstadual?: string;
  nome: string;
  nomeFantasia?: string;
  indicadorIETomador?: number;
  fone?: string;
  endereco: string;
  enderecoNumero: string;
  bairro: string;
  codigoMunicipio: string | number;
  nomeMunicipio: string;
  uf: string;
  cep: string;
  codigoPais?: string;
  nomePais?: string;
}

export interface CTeValoresComponenteDto {
  nome: string;
  valor: number;
}

export interface CTeValoresPrestacaoDto {
  valorPrestacaoServico: number;
  valorReceber: number;
  valorTotalTributos: number;
  componentes: CTeValoresComponenteDto[];
}

export interface CTeCargaQuantidadeDto {
  codigoUnidadeMedida: string;
  tipoMedida: string;
  quantidadeCarga: number;
}

export interface CTeCargaDto {
  valorCarga: number;
  produtoPredominante: string;
  outraCaracteristica?: string;
  quantidades: CTeCargaQuantidadeDto[];
}

export interface CTeComplementoDto {
  observacao?: string;
}

export interface CTeDocumentoDto {
  tipoDocumento: number;
  chaveDocumento: string;
}

export interface CTeAutorizacaoDto {
  codigoStatusEnvio: number;
  descricaoStatusEnvio: string;
  codigoStatusResposta: number;
  descricaoMotivoResposta: string;
}

export interface CTeDto {
  id?: number;
  serie: number;
  numeroCte: number;
  tributacaoId: number;
  tipoCte: number;
  tipoServico: number;
  finalidadeCte: number;
  modal: number;
  retira: number;
  tipoTomador: number;
  rntrc: string;
  codigoMunicipioInicio: number;
  nomeMunicipioInicio: string;
  ufInicio: string;
  codigoMunicipioFim: number;
  nomeMunicipioFim: string;
  ufFim: string;
  destinatario: CTePessoaDto;
  remetente: CTePessoaDto;
  tomador?: CTePessoaDto;
  valoresPrestacao: CTeValoresPrestacaoDto;
  carga: CTeCargaDto;
  complemento?: CTeComplementoDto;
  documentos: CTeDocumentoDto[];
  emissaoDataHora?: string;
  autorizacao?: CTeAutorizacaoDto;
}

export const tipoCteOptions = [
  { value: 0, label: "0 - Normal" },
  { value: 1, label: "1 - Complemento de Valores" },
  { value: 2, label: "2 - Anulação" },
  { value: 3, label: "3 - Substituto" },
];

export const tipoServicoOptions = [
  { value: 0, label: "0 - Normal" },
  { value: 1, label: "1 - Subcontratação" },
  { value: 2, label: "2 - Redespacho" },
  { value: 3, label: "3 - Redespacho Intermediário" },
  { value: 4, label: "4 - Serviço Vinculado a Multimodal" },
];

export const finalidadeCteOptions = [
  { value: 0, label: "0 - Normal" },
];

export const modalOptions = [
  { value: 1, label: "01 - Rodoviário" },
  { value: 2, label: "02 - Aéreo" },
  { value: 3, label: "03 - Aquaviário" },
  { value: 4, label: "04 - Ferroviário" },
  { value: 5, label: "05 - Dutoviário" },
  { value: 6, label: "06 - Multimodal" },
];

export const retiraOptions = [
  { value: 0, label: "0 - Sim" },
  { value: 1, label: "1 - Não" },
];

export const tipoTomadorOptions = [
  { value: 0, label: "0 - Remetente" },
  { value: 1, label: "1 - Expedidor" },
  { value: 2, label: "2 - Recebedor" },
  { value: 3, label: "3 - Destinatário" },
  { value: 4, label: "4 - Outros" },
];

export const tipoDocumentoOptions = [
  { value: 1, label: "1 - NF-e (Chave de Acesso)" },
  { value: 2, label: "2 - Declaração" },
  { value: 3, label: "3 - Outros" },
];

export const unidadeMedidaOptions = [
  { value: "00", label: "00 - M3" },
  { value: "01", label: "01 - KG" },
  { value: "02", label: "02 - TON" },
  { value: "03", label: "03 - UNIDADE" },
  { value: "04", label: "04 - LITROS" },
  { value: "05", label: "05 - MMBTU" },
];

export const STORAGECTE_KEY = "cteTemp";

export function updateLocal<T extends object>(
  key: string,
  partial: Partial<T> | null
) {
  if (partial === null) {
    localStorage.removeItem(key);
    return;
  }

  const stored = localStorage.getItem(key);
  const current: T = stored ? JSON.parse(stored) : ({} as T);

  const updated: T = {
    ...current,
    ...partial,
  };

  localStorage.setItem(key, JSON.stringify(updated));
}

export function getLocal<T>(key: string): T | null {
  const stored = localStorage.getItem(key);
  return stored ? (JSON.parse(stored) as T) : null;
}
